import type { Date as ProtoDate } from "@/gen/google/type/date_pb";

/**
 * Format google.type.Date to DD/MM/YYYY format for display
 * @param protoDate - Proto date object with year, month, day fields
 * @returns Formatted date string (DD/MM/YYYY) or empty string if undefined
 */
export function formatProtoDate(protoDate: ProtoDate | undefined): string {
  if (!protoDate) {
    return "";
  }

  // Pad day and month with leading zeros if needed
  const day = String(protoDate.day).padStart(2, "0");
  const month = String(protoDate.month).padStart(2, "0");
  const year = String(protoDate.year);

  return `${day}/${month}/${year}`;
}

// Note: For converting proto Date to JavaScript Date, use fromProtoDate from @/utils/date
